/**
 * Quick View
 * -----------------------------------------------------------------------------
 * A collection of product quick view
 */
 
$(document).ready(function () {  
    quickView();    
});
$('button.close').click(function(){ 
  if($('#quickModal').hasClass("show")){
    $('#quickModal').removeClass('show');
  }
  $( ".qv-product-images" ).slick('unslick');
  // $( ".quantity__input" ).val(1);
  $( ".qv-product-images" ).empty();
  $( ".qv-product-options" ).empty();
  $( ".qv-add-to-cart-response" ).attr('class', 'qv-add-to-cart-response').empty();  
  $(".product_wish").attr("data-product-handle", "");
  //console.log("calling close buuuton");
});


function quickView() { 

  var colorCodes = {
    "black": "#000000",
    "black/red": "#FF0000", // example color code
    "black/yellow": "#FFFF00", // example color code
    "blue": "#0000FF",
    "fuchsia": "#FF00FF",
    "fusion black turbo 3 1/2\"": "#333333", // example color code
    "fusion blue channel refill": "#3366FF", // example color code
    "fusion blue stroke blade": "#3399FF", // example color code
    "fusion green turbo 3 1/2\"": "#00CC00", // example color code
    "fusion orange channel refill": "#FF6600", // example color code
    "fusion orange stroke blade": "#FF9900", // example color code
    "fusion orange turbo 3 1/2\"": "#FF6600", // example color code
    "fusion pink turbo 3 1/2\"": "#FF99CC", // example color code
    "fusion red turbo 3 1/2\"": "#FF0000", // example color code
    "fusion turbo pro black 5 1/2\"": "#333333", // example color code
    "fusion turbo pro green 5 1/2\"": "#00CC00", // example color code
    "fusion yellow turbo 3 1/2\"": "#FFFF00", // example color code
    "gold": "#FFD700",
    "gray": "#808080",
    "green": "#008000",
    "orange": "#FFA500",
    "pink": "#FFC0CB",
    "purple": "#800080",
    "red": "#FF0000",
    "red - 80 duro": "#FF0000", // example color code
    "silver": "#C0C0C0",
    "tifanny - 70 duro": "#00CED1", // example color code
    "white": "#FFFFFF",
    "yellow": "#FFFF00",
    "black - 90 duro" : '#000000'
};

  
  $(document).on("click",".product-button-eye",function(){
    var $nextDiv = $(this).next(); // Get the next div after .product-button-eye
    $('.quick_view_wishlist_class').removeClass('active');
    if ($nextDiv.hasClass('wishlist') && $nextDiv.hasClass('active')) {
        // The next div has both wishlist and active classes
        $('.quick_view_wishlist_class').addClass('active');
    }
    $("#quickModal").toggleClass('show');  
      $("#product_wish").val();
       
    	var product_handle = $(this).data('handle');
    console.log("product_handle=".product_handle);
     $(".product_wish").val( product_handle );
        $('#quick-view').addClass(product_handle);
        $( ".qv-product-bundle" ).val( product_handle );
      	var set_variant_option = $( ".qv-product-options" ).data( 'prd_variants' );
        var set_variant_radious = $( ".qv-product-options" ).data( 'prd_radious' );    
        var variant_option = 'dropdown'; //default variation options
        var variant_radious = true;
    
        if( typeof set_variant_option !== 'undefined' && set_variant_option != '' ){
            variant_option = set_variant_option;
        }
        if( typeof set_variant_radious !== 'undefined' ){
            variant_radious = set_variant_radious;
        }         
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) { 
         
            var prd_id = product.id;        
            var title = product.title;
            var type = product.type;
            var price = 0;
            var sale_price = parseFloat(product.compare_at_price / 100).toFixed(2);
            var original_price = 0;
            var desc = product.description;          
            var images = product.images;
            var variants = product.variants;
            var options = product.options;
            var url = '/products/' + product_handle;
            var color = false;
            var option_name_arr = [];
            var option_value_arr = [];
            var wishlist_title= product.id;
            var wishlist_product_handle = product.handle;
            var wishlist_hnadle= product.handle;
            var wishlist_data_handle = product.handle;
                      
            $('.product_model_title span').show();            
            if( desc.length == false ){ $('.product_model_title span').hide(); }
            $('.qv-product-title').html('<a href="'+url+'">'+title+'</a>');
            $( ".review_section" ).html( '<span class="shopify-product-reviews-badge" data-id="'+prd_id+'"></span>' );
            $("#product_handle").val(product_handle);
            $('.qv-product-type').text(type);
            $('.qv-product-description').html(desc);
            $('.view-').attr('href', url);
          	$(".product_sale_price").empty();
            $(".qv-wishlist .product-wishlist").attr("data-product-id", wishlist_title );
            $(".qv-wishlist .product-wishlist").attr("data-product-handle", wishlist_product_handle );
            $(".qv-wishlist .product-wishlist").attr("data-handle", wishlist_hnadle );
            $("#product_wish").attr("data-product-handle", wishlist_data_handle);
          
            if( sale_price > 0 ){                
            	$('.product_sale_price').append('<span class="price__badge price__badge--sale" aria-hidden="true"><span>Sale</ > </span>');
            }
          
            var imageCount = $(images).length;
            $(images).each(function (i, image) {
                if (i == imageCount - 1) {
                    var image_embed = '<div><img class="slideimage" src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                  
                    $('.qv-product-images').append(image_embed);
                 
                      $('.qv-product-images').slick({
                        'dots': false,
                        'arrows': true,
                        'respondTo': 'min',
                        'useTransform': false
                      }).css('opacity', '1');
                } else {
                  console.log("Else part");
                    image_embed = '<div><img class="slideimage" src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                    $('.qv-product-images').append(image_embed);
                    
                }
            });
          
        
            $(options).each(function (i, option) {              
              var string = option.values ;              
              if( string != "Default Title" ){                
                       
                var opt = option.name;                  
                var sized = opt.toLowerCase().indexOf( 'size' ); 
                if( opt.toLowerCase().indexOf( 'color' ) != -1 || opt.toLowerCase().indexOf( 'colour' ) != -1 ){
                    var color = true;                    
                }


                  var selectClass = '.option.' + opt.toLowerCase();               
                $('.qv-product-options').append('<div class="variant_options option-selection-' + opt.toLowerCase() + '"><span class="option-title">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
                $(option.values).each(function (i, value) {   
                    let ori_color = value.toLowerCase();
                    $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' +  value + '</option>');
                });
                
             // var selectClass = '.option.' + opt.toLowerCase();
             //    $('.qv-product-options').append('<div class="variant_options option-selection-' + opt.toLowerCase() + '"><span class="option-title testt">' + opt + '</span></div>');

             //    $(option.values).each(function (i, value) { 
                  
             //      let ori_color = value.toLowerCase();
                  
             //      $('.qv-product-varients').append('<div class="variant_options option-selection-' + opt.toLowerCase() + ' option-' + i + '"><input class="option-' + i + ' option ' + opt.toLowerCase() + '" name="color" style="background:' + colorCodes[ori_color] + '" title="'+value+'"></div>');

             //    });

                
                if( variant_option == 'box' ){                  
                    $( '.qv-product-options' ).append( '<div class="swatch clearfix swatch-'+opt.toLowerCase()+'" data-option-index="'+i+'"><div class="header">'+opt+'</div></div>' );                                        
                  	$(option.values).each(function (i, value) {                     
                     if( opt.toLowerCase() == 'size' ){
                         var n = 0;                       
                         if( n == i ){                          
                          var first_variant = true;                  
                         }
                     }else if( opt.toLowerCase() == 'color' || opt.toLowerCase() == 'colour' ){
                       var n = 0;                       
                         if( n == i ){                          
                          var first_variant = true;                  
                         }
                       var n = 1;
                     } else{ 
                         var n = 0;                         
                         if( n == i ){                          
                          var first_variant = true;                  
                         }
                         var n = 2;
                       }                      
                        var swatch_html = '<div data-value="'+value+'" class="swatch-element ';
                        if ( color ){
                            swatch_html += 'color ';
                        }
                        swatch_html += value +'">';
                        if( color ){
                            swatch_html += '<div class="tooltip">'+value+'</div>';
                        }                       
                        swatch_html += '<input id="swatch-'+n+'-'+value+'" type="radio" class="radion_checked" name="option-'+n+'" value="'+value+'" ';
                        if( first_variant ){ 
                            swatch_html += 'checked ';
                        } 
                        swatch_html +=  '/>';
                        swatch_html += '<label for="swatch-'+n+'-'+value+'" '
                        if ( variant_radious ){
                            swatch_html += 'class="radious"';
                        }
                        swatch_html += 'class="';
                        if( color ){
                            var color_value_obj = value.split( ' ' );
                            var color_value = color_value_obj[ color_value_obj.length - 1 ];
                            swatch_html += 'swatch_bg_color_'+color_value
                        }
                        if( variant_radious ){
                            swatch_html += 'border-radius: 50%;';
                        }
                        swatch_html += '">';
                        if( !color ){
                            swatch_html += value;
                        }
                        swatch_html += '</label>';
                        swatch_html += '</div>';                       
                        $( '.swatch-'+opt.toLowerCase() ).append( swatch_html );                      
                    });
                    $( '.option-'+i ).closest('.variant_options').hide();                    
                 }
              } 
            }); 

            $('.variant_options input').click(function(){
              $('.variant_options').removeClass('active');
              $(this).parent().addClass('active');
            });
          
            $(product.variants).each(function (i, v) {
                if( v.available ){                      
                  $('.qv-add-button').attr('disabled', false);
                  $('.qv-add-button').val('Add to Cart');
                }else{                      
                  $('.qv-add-button').attr('disabled', true);
                  $('.qv-add-button').val("Sold Out");
                }
                if (v.inventory_quantity == 0) {
                    $('.qv-add-button').prop('disabled', true).val('Sold Out');
                    $('.qv-add-to-cart').hide();
                    $('.qv-product-price').text('Sold Out').show();
                    return true
                } else {                  
                  var select = '<select id="product-select-qv" name="id">';
                  var selected = 'selected';
                    for (i = 0; i < product.variants.length; i++) {
                      var _var = product.variants[i];
                      if(_var.available) {
                        select += '<option value="' + _var.id + '"' + selected +'>' + _var.title + '</option>'
                        selected = '';
                      }
                    }
                  select += '</select>';
                  $(".variation_option").html(select);
                    price = parseFloat(v.price / 100).toFixed(2);
                    original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                    $('.qv-product-price').text('$' + price);
                    if (original_price > 0) {
                        $('.qv-product-original-price').text('$' + original_price).show();
                    } else {
                        $('.qv-product-original-price').hide();
                    }
                    $('select.option-0').val(v.option1);
                    $('select.option-1').val(v.option2);
                    $('select.option-2').val(v.option3);
                    return false
                }
            });
        });
        var productURL = '/products/' + product_handle;
		$(".qv-view-details a").attr("href", productURL);   
         var productwishlisthandle = $(".product-wishlist").data("handle");
       $( '#quickModal' ).addClass( 'show' );
    });
  
    $( document ).on( "click", "#quickModal .swatch-element", function( e ){
        e.preventDefault();        
        var option_index = $( this ).closest( ".swatch" ).data( "option-index" );       
        if( typeof option_index !== 'undefined' ){
            var selected_value = $(this).data( 'value' );            
            $( this ).closest( ".qv-product-options" ).find( '.option-'+option_index ).val( selected_value );
            $( this ).closest( ".qv-product-options" ).find( '.option-'+option_index ).trigger( 'change' );
        }
    });
    
    $(document).on("change", "#quickModal select", function () {        
        var product_handle = $(this).closest(".modal-body").find( '.qv-product-bundle' ).val();  
        var selectedOptions = '';
        // $('#quickModal select').each(function (i) {
        //     if (selectedOptions == '') {
        //         selectedOptions = $(this).val();
        //     } else {
        //         selectedOptions = selectedOptions + ' / ' + $(this).val();
        //     }
        // });
        if ($('#quickModal select option:selected').length > 0) {
            console.log("gfhghg");
            selectedOptions = $('#quickModal select option:selected').val();
        }
        
        var timestamp = new Date().getTime(); // Generate a timestamp
        jQuery.getJSON('/products/' + product_handle + '.js?timestamp=' + timestamp, function (product) {
          	var images = product.images;
            $(product.variants).each(function (i, v) {
                if (v.title == selectedOptions) {                    
                    var price = parseFloat(v.price / 100).toFixed(2);
                    var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                           
					          if( v.available ){                      
                      $('.qv-add-button').attr('disabled', false);
                      $('.qv-add-button').val('Add to Cart');
                    }else{                      
                      $('.qv-add-button').attr('disabled', true);
                      $('.qv-add-button').val("Sold Out");
                    }
                  
                    $('.product_sale_price').empty();
                    $('.qv-product-price').text('$' + price);
                
                    if( original_price > 0 ){
                        $('.qv-product-original-price').show();
                        $('.qv-product-original-price').text('$' + original_price);
                        $('.product_sale_price').append('<span class="price__badge price__badge--sale" aria-hidden="true"><span>Sale</span> </span>');
                        
                    } else {
                        $('.qv-product-original-price').hide();
                    }

                    var url = '';
                    if( v.featured_image != null ){
                      url = v.featured_image.src;
                      url = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
                    }

                    $(images).each(function (i, image) {
                     image = image.replace('//', "");
                        if( image == url ){
                          $('.qv-product-images').slick('slickGoTo', i);
                        }
                  });
                }                 
            });   
        });
    });
  	
    $(document).on("click", ".qv-add-button", function () {
      var product_handle = $(this).closest(".modal-body").find('.qv-product-bundle').val();
      var qty = $(this).closest(".modal-body").find('.quantity__input').val();
      var selectedOptions = '';
      var var_id = '';
       $(this).closest(".modal-body").find('.loading__spinner').removeClass('hidden');
      if ($('#quickModal select option:selected').length > 0) {
          console.log("gfhghg");
          selectedOptions = $('#quickModal select option:selected').val();
      }

      // $('#quickModal select').each(function (i) {
      //     if (selectedOptions == '') {
      //         selectedOptions = $(this).val();
      //     } else {
      //         selectedOptions = selectedOptions + ' / ' + $(this).val();
      //     }
      // });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                  var_id = v.id;
                  processCart(qty, var_id); // Pass quantity and variant ID to processCart
              } else if (selectedOptions == '') {
                  var_id = v.id;
                  processCart(qty, var_id); // Pass quantity and variant ID to processCart
              }
          });
      });
  });
  
  function processCart(qty, var_id) {
      jQuery.post('/cart/add.js', { quantity: qty, id: var_id },
          null,
          "json"
      ).done(function () {
          // After successfully adding the item to the cart, update the cart and open the cart drawer
          $('.qv-add-view-details .loading__spinner').addClass('hidden');
          $('.qv-add-to-cart-response').addClass('success').html('<span>' + 'Item added to Cart');
          updateCartDrawer();
      }).fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $('.qv-add-view-details .loading__spinner').addClass('hidden');
          $('.qv-add-to-cart-response').addClass('error').html('Item in Sold Out');
      });
  }
  
  function updateCartDrawer() {
     fetch(`/cart?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
         $('.drawer').removeClass('is-empty'); // Remove the 'is-empty' class
         let totalQuantity = 0;
         $('.drawer .quantity__input').each(function() {
            totalQuantity += parseInt($(this).val()) || 0; // Parse the value of quantity and add to totalQuantity
        });
  
        $('.cart-count-bubble').remove();
        $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">'+totalQuantity+'</span><span class="visually-hidden">'+totalQuantity+' items</span></div>');
      })
      .catch((e) => {
        console.error(e);
      });
  }

  
    $( '#quickModal' ).on( "hidden.bs.modal", function( e ){
        $( ".qv-product-images" ).slick('unslick');
        $( ".quantity__input" ).val(1);
        $( ".qv-product-images" ).empty();
        $( ".qv-product-options" ).empty();
        $( ".qv-add-to-cart-response" ).attr('class', 'qv-add-to-cart-response').empty();
    });

   $(document).on("click", ".qv-buy-now-button", function () {
      var product_handle = $(this).closest(".modal-body").find( '.qv-product-bundle' ).val();
      var qty = $(this).closest(".modal-body").find('.quantity__input').val();
      var selectedOptions = '';
      var var_id = '';
      console.log("qty=", qty);

       $.ajax({
        url: '/cart/clear.js',
        type: 'POST',
        dataType: 'json',
        success: function(response) {
          // Cart cleared successfully
          console.log('Cart cleared successfully');
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // Error occurred while clearing the cart
          console.error('Error clearing cart:', errorThrown);
        }
      });

      $('#quickModal select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
            processCart();
          }else if( selectedOptions == '' ){
            var_id = v.id;
            processCart();
          }
        });
      });
     
      function processCart() {
        jQuery.post('/cart/add.js', { quantity: qty, id: var_id },
          null,
          "json"
        ).done(function () {
          $('.qv-add-to-cart-response').addClass('success').html('<span>' + 'Item added to Cart.');
          
          // Redirect to the checkout page after the cart is updated
          window.location.href = '/checkout';
        }).fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
        });
      }

    });
};